import { GlobalRoles, IAccountingUnit, IUser } from '@monorepo/interfaces';
import { FleetBrowseFilters } from '../../shared/interfaces/fleet-management/fleet-browse-filter.interface';
import { HttpParams } from '@angular/common/http';

export const filteredAccountingUnits = (
    user: IUser | undefined,
    accountingUnits: IAccountingUnit[]
): IAccountingUnit[] => {
    const isSystemAdmin = user?.permissions.some(permission => permission.role === GlobalRoles.SYSTEM_ADMIN);
    let filteredAccountingUnits: IAccountingUnit[];
    if (isSystemAdmin) {
        filteredAccountingUnits = accountingUnits;
    } else {
        const userAccountingUnitIds =
            user?.permissions.map(permission => permission.accountingUnit?.id).filter(id => id !== undefined) || [];
        filteredAccountingUnits = accountingUnits.filter(unit => userAccountingUnitIds.includes(unit.id));
    }

    return Array.from(new Set(filteredAccountingUnits));
};

export const getFleetFilterParams = (filter: FleetBrowseFilters, params: HttpParams): HttpParams => {
    if (filter.changeState && filter.changeState.length > 0) {
        filter.changeState.forEach(value => {
            params = params.append('changeState', value);
        });
    }
    if (filter.changeFlags && filter.changeFlags.length > 0) {
        filter.changeFlags.forEach(value => {
            params = params.append('changeFlags', value);
        });
    }
    if (filter.engineType && filter.engineType.length > 0) {
        filter.engineType.forEach(value => {
            params = params.append('engineType', value);
        });
    }
    if (filter.frequencyUnit && filter.frequencyUnit.length > 0) {
        filter.frequencyUnit.forEach(value => {
            params = params.append('frequencyUnit', value);
        });
    }
    if (filter.intercompanyLease && filter.intercompanyLease.length > 0) {
        filter.intercompanyLease.forEach(value => {
            params = params.append('intercompanyLease', value);
        });
    }
    if (filter.paymentForm && filter.paymentForm.length > 0) {
        filter.paymentForm.forEach(value => {
            params = params.append('paymentForm', value);
        });
    }
    if (filter.subleaseType && filter.subleaseType.length > 0) {
        filter.subleaseType.forEach(value => {
            params = params.append('subleaseType', value);
        });
    }
    if (filter.searchTerm && filter.searchTerm.length > 0) {
        params = params.set('searchTerm', filter.searchTerm);
    }
    return params;
};
